import { range } from 'lodash'

import { SelectInput } from '~/components/component-library'
import { plural } from '~/utils/display'

export const ThresholdSelect = ({
  signerCount,
  threshold,
  setThreshold,
}: {
  signerCount: number
  threshold: number
  setThreshold: (threshold: number) => void
}) => {
  if (signerCount <= 1) return null

  return (
    <SelectInput
      label="Threshold"
      tooltip="The number of passkeys required to approve a transaction"
      options={range(signerCount, 0, -1).map((num) => ({
        label: `${num} ${plural('passkey', num)} needed`,
        value: num,
      }))}
      selectedOption={threshold}
      placeholder={`${threshold} ${plural('passkey', threshold)} needed`}
      selectValue={setThreshold}
    />
  )
}
